import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { cleanObj } from '../../../../../../shared/utils/objects';
import { PqrStrategicAlly } from '../../../../../../shared/types/modules/pqr';
import { SarlaftStrategicAllyProps } from './props';
import { StrategicAlly } from '../../../../../../shared/types/modules/strategicAlly';
import { ISelect } from '../../../../../../shared/types/shared';

export const useSarlaftStrategicAlly = ({
    data,
    onChangeData,
    onChangeFormik,
}: SarlaftStrategicAllyProps) => {
    const [open, setOpen] = useState(false);

    const onSubmit = (data: PqrStrategicAlly) => {
        if (onChangeData)
            onChangeData(cleanObj(data) || ({} as PqrStrategicAlly));
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    const handleChangeOpenDialog = () => {
        setOpen(!open);
    };

    const handleChangeStrategicAlly = (data?: StrategicAlly) => {
        formik.setFieldValue('strategicAlly', data?.id || '');
        formik.setFieldValue('strategicAllyLabel', data?.name || '');
        setOpen(false);
    };

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        if (formik) formik.validateForm();
    }, [formik.values.strategicAlly]);

    useEffect(() => {
        formik?.setFieldValue(
            'strategicAlly',
            (data?.strategicAlly as ISelect)?.id || ''
        );
        formik?.setFieldValue(
            'strategicAllyLabel',
            (data?.strategicAlly as ISelect)?.name || ''
        );
    }, [data]);

    return {
        formik,
        handleChangeStrategicAlly,
        handleChangeOpenDialog,
        open,
    };
};
